export default __webpack_public_path__ + "static-front/media/TaskIcon.269c8d2f.svg";